import { gql } from '@apollo/client';
import { CORE_SAVED_SEARCH_FIELDS } from '@general/graphql/fragments/saved-searches';
import { CORE_CONTACT_FIELDS } from '@general/graphql/fragments/contact';
import { CORE_PROPERTY_FIELDS } from '@general/graphql/fragments/property';
import { CORE_EVENT_FIELDS } from '@general/graphql/fragments/event';

export const MEMBERS_QUERY = gql`
    ${CORE_CONTACT_FIELDS}
    query getMembers($ids: [ID!]) {
        members(ids: $ids) {
            ...CoreContactFields
            activeCommitteesFull {
                committee_id
                code
                name
                position
            }
            linkedinUrl
            photoUrl
            twitterUrl
            company {
                recordId
                name
            }
            address {
                purpose
                city
                stateProvince
                country
            }
            status
        }
    }
`;

export const MEMBER_PROFILE_QUERY = gql`
    ${CORE_CONTACT_FIELDS}
    ${CORE_SAVED_SEARCH_FIELDS}
    ${CORE_PROPERTY_FIELDS}
    ${CORE_EVENT_FIELDS}
    query getMembers($ids: [ID!]) {
        members(ids: $ids) {
            ...CoreContactFields
            activeCommitteesFull {
                committee_id
                code
                name
                position
            }
            address {
                purpose
                address
                address2
                address3
                city
                stateProvince
                country
                zip
            }
            blogUrl
            company {
                recordId
                name
                primaryBusinessType {
                    code
                    name
                }
            }
            description
            designations
            displayEmail
            events {
                ...CoreEventFields
            }
            firstCollege {
                code
                name
            }
            firstGraduationYear
            joinDate
            linkedinUrl
            memberType
            recognition
            secondCollege {
                code
                name
            }
            secondGraduationYear
            secondaryBusinessTypes {
                code
                name
            }
            twitterUrl
            website
            workPhone
            savedSearches {
                ...CoreSavedSearchFields
            }
            properties {
                ...CorePropertyFields
            }
        }
    }
`;
